import { useMediaQuery } from '@mui/material';
import { FC, useMemo } from 'react';
import { SecondaryTextTypography } from '../../../../../../App.styles';
import { Container, Icon, Icons, Typography } from '../../../../../../stories/atoms';
import { RotateDirection } from '../../../../../../stories/atoms/icon/Icon.styles';
import { muiTheme } from '../../../../../../theme';
import { formatAmountWithSeparator } from '../../../../../../utils';
import { AccuracyContainer, StyledValueTypography } from '../StockAccuracyWidget.styles';

const HIGH_THRESHOLD = 97;
const LOW_THRESHOLD = 95;

export enum AccuracyValueEnum {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

type StockAccuracyCardProps = {
  accuracyIcon: Icons;
  accuracyTitle: string;
  accuracyText: string;
  accuracyValue: number;
  rotate?: RotateDirection;
  showColor?: boolean;
};

export const StockAccuracyCard: FC<StockAccuracyCardProps> = ({
  accuracyIcon,
  accuracyTitle,
  accuracyText,
  accuracyValue,
  rotate,
  showColor = false,
}) => {
  const isMobileView = useMediaQuery(muiTheme.breakpoints.down('tabletLandscape'));

  const accuracyColor = useMemo(() => {
    if (accuracyValue >= HIGH_THRESHOLD) {
      return AccuracyValueEnum.SUCCESS;
    } else if (accuracyValue >= LOW_THRESHOLD && accuracyValue < HIGH_THRESHOLD) {
      return AccuracyValueEnum.WARNING;
    } else {
      return AccuracyValueEnum.ERROR;
    }
  }, [accuracyValue]);

  return (
    <AccuracyContainer data-testid="accuracy-container" isMobile={isMobileView}>
      <Container wrap="nowrap" direction="horizontal" style={{ alignItems: 'center', gap: '4px' }}>
        <Icon icon={accuracyIcon} size="small" rotate={rotate} />
        <Typography type="body3">{accuracyTitle}</Typography>
      </Container>
      <SecondaryTextTypography type={isMobileView ? 'caption' : 'body2'}>{accuracyText}</SecondaryTextTypography>
      <StyledValueTypography showColor={showColor} accuracy={accuracyColor} type="h4" textAlign="right">
        {formatAmountWithSeparator(accuracyValue)}%
      </StyledValueTypography>
    </AccuracyContainer>
  );
};
